module.exports = __webpack_public_path__ + "media/img/feature-icon-attachment-adb6018b18fa5507558ddf5cceddc8ae.svg";